import React from "react";
import Typography, { TypographyProps } from "@mui/material/Typography";
import Box, { BoxProps } from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

const InfoTag: React.FC<{
  isTooltip?: boolean;
  content: string | number;
  icon?: React.ReactNode;
  boxProps?: BoxProps;
  typographyProps?: TypographyProps;
}> = ({ isTooltip = false, content, icon, boxProps, typographyProps }) => {
  const InfoTagComponent = (
    <Box
      display="flex"
      alignItems="center"
      columnGap={0.5}
      px={2.5}
      {...(boxProps || {})}
    >
      {icon}
      <Typography variant="body1" {...(typographyProps || {})}>
        {content}
      </Typography>
    </Box>
  );

  // condition for wrapping the infotag under tooltip
  return isTooltip ? (
    <Tooltip title={content} placement="top" arrow>
      {InfoTagComponent}
    </Tooltip>
  ) : (
    InfoTagComponent
  );
};

export default InfoTag;
